import { mainSiteUrl } from '@/mocks/categories';

export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center bg-background-50 pt-16">
      <div className="w-full px-6 md:px-10">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="w-full lg:w-5/12 flex flex-col items-start">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-foreground-950 leading-tight">
              Yoybuy <span className="italic text-primary-500">Spreadsheet</span>
              <br />
              <span className="text-2xl md:text-3xl lg:text-4xl font-sans font-light text-foreground-700">— умный способ покупать товары из Китая</span>
            </h1>

            <p className="mt-6 text-base md:text-lg text-foreground-600 leading-relaxed max-w-md">
              Покупайте товары через проверенные китайские платформы с помощью удобных таблиц. Yoybuy, Kakobuy и Superbuy Spreadsheet — всё в одном месте.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mt-8">
              <a
                href={mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-7 py-3.5 bg-foreground-950 text-white text-sm font-semibold rounded-lg hover:bg-foreground-800 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-shopping-bag-3-line text-base w-4 h-4 flex items-center justify-center"></i>
                <span>yoybuy sheet</span>
                <i className="ri-arrow-right-up-line text-base w-4 h-4 flex items-center justify-center"></i>
              </a>
              <a
                href={mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-7 py-3.5 border border-foreground-300 bg-background-100 text-foreground-900 text-sm font-semibold rounded-lg hover:bg-background-200 transition-colors cursor-pointer whitespace-nowrap"
              >
                <span>buy it now</span>
                <i className="ri-arrow-right-up-line text-base w-4 h-4 flex items-center justify-center"></i>
              </a>
            </div>
          </div>

          <div className="w-full lg:w-7/12">
            <div className="grid grid-cols-2 gap-3 md:gap-4">
              <div className="relative rounded-2xl overflow-hidden mt-8">
                <div className="aspect-[4/5] w-full">
                  <img
                    src="https://readdy.ai/api/search-image?query=Pair%20of%20trendy%20chunky%20sneakers%20on%20light%20sage%20green%20concrete%20floor%20with%20soft%20sunlight%20casting%20gentle%20shadows%2C%20modern%20streetwear%20product%20photography%2C%20clean%20composition%2C%20editorial%20style%2C%20fresh%20natural%20aesthetic&width=600&height=750&seq=hero-new-01&orientation=portrait"
                    alt="Обувь"
                    title="Обувь — yoybuy spreadsheet"
                    className="w-full h-full object-cover object-top"
                    loading="lazy"
                  />
                </div>
                <div className="absolute top-3 right-3 bg-foreground-950/60 backdrop-blur-sm text-white text-xs font-medium px-3 py-1.5 rounded-full whitespace-nowrap">
                  Обувь
                </div>
              </div>

              <div className="relative rounded-2xl overflow-hidden -mt-4">
                <div className="aspect-[4/5] w-full">
                  <img
                    src="https://readdy.ai/api/search-image?query=Oversized%20hoodie%20hanging%20on%20wooden%20hanger%20against%20soft%20terracotta%20colored%20wall%2C%20minimalist%20fashion%20editorial%2C%20warm%20indoor%20lighting%2C%20clean%20Scandinavian%20aesthetic%2C%20textured%20fabric%20detail%2C%20cozy%20atmosphere&width=600&height=750&seq=hero-new-02&orientation=portrait"
                    alt="Худи"
                    title="Худи — yoybuy spreadsheet"
                    className="w-full h-full object-cover object-top"
                    loading="lazy"
                  />
                </div>
                <div className="absolute top-3 right-3 bg-foreground-950/60 backdrop-blur-sm text-white text-xs font-medium px-3 py-1.5 rounded-full whitespace-nowrap">
                  Худи
                </div>
              </div>

              <div className="relative rounded-2xl overflow-hidden -mt-4">
                <div className="aspect-[4/5] w-full">
                  <img
                    src="https://readdy.ai/api/search-image?query=Elegant%20canvas%20tote%20bag%20leaning%20against%20stack%20of%20books%20on%20light%20gray%20linen%20surface%20near%20window%2C%20soft%20natural%20daylight%2C%20minimalist%20lifestyle%20photography%2C%20warm%20relaxed%20composition&width=600&height=750&seq=hero-new-03&orientation=portrait"
                    alt="Сумки"
                    title="Сумки — yoybuy spreadsheet"
                    className="w-full h-full object-cover object-top"
                    loading="lazy"
                  />
                </div>
                <div className="absolute top-3 right-3 bg-foreground-950/60 backdrop-blur-sm text-white text-xs font-medium px-3 py-1.5 rounded-full whitespace-nowrap">
                  Сумки
                </div>
              </div>

              <div className="relative rounded-2xl overflow-hidden mt-8">
                <div className="aspect-[4/5] w-full">
                  <img
                    src="https://readdy.ai/api/search-image?query=Premium%20fragrance%20bottle%20with%20golden%20accents%20on%20dark%20walnut%20wood%20surface%20with%20soft%20candlelight%20glow%2C%20luxury%20beauty%20photography%2C%20warm%20amber%20tones%2C%20elegant%20atmospheric%20composition&width=600&height=750&seq=hero-new-04&orientation=portrait"
                    alt="Парфюмерия"
                    title="Парфюмерия — yoybuy spreadsheet"
                    className="w-full h-full object-cover object-top"
                    loading="lazy"
                  />
                </div>
                <div className="absolute top-3 right-3 bg-foreground-950/60 backdrop-blur-sm text-white text-xs font-medium px-3 py-1.5 rounded-full whitespace-nowrap">
                  Парфюмерия
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}